// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"282":"3438931d","432":"5f61d131","656":"3438931d"}[chunkId] + ".chunk.css";
};